module.exports = "<p>\n  victor-dashboard works!\n</p>\n"